// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","844":"component---src-pages-privacy-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"c1edd7760512ae370e8d","844":"e8d87d9912a5d3efeb62","883":"6d77e2a9c25fdcfaf372"}[chunkId] + ".js";
};